export default __webpack_public_path__ + "c9d8084a2fd540b72503ecf79cd1c698.png";